import type { ReactNode } from 'react'
import React, { useMemo, createContext, useContext } from 'react'

const FamilyColumnContext = createContext({ type: 'spouses', showPreferred: false } as FamilyColumnProviderValues)

type FamilyColumnProviderValues = {
  type: 'spouses' | 'parents'
  showPreferred: boolean
}

type FamilyColumnProviderProps = FamilyColumnProviderValues & {
  children: ReactNode
}

export const useFamilyColumnValues = (): FamilyColumnProviderValues => useContext(FamilyColumnContext)

export default function FamilyColumnProvider({
  children,
  type,
  showPreferred,
}: FamilyColumnProviderProps): JSX.Element {
  const value = useMemo(() => ({ type, showPreferred }), [showPreferred, type])
  return <FamilyColumnContext.Provider value={value}>{children}</FamilyColumnContext.Provider>
}
